import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";


import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { refundService } from "@/services/api/cresivoxServer";


import { REDUCER_NAME, iRefundResponse,iUpdateRefund} from './Types';
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);


export const updateRefund = createAsyncThunk<
iGenericResponse<any | null> | null,
{refundId:string, data: iUpdateRefund},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("updateRefund"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({refundId,data}, {rejectWithValue}) => {
	try {
		const response = await refundService.updateRefund(refundId,data);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								data: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);


export const getRefundList = createAsyncThunk<
  iGenericResponse<any | null> | null,
{status:string},
  {
	  rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("refundList"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async ({status}, {rejectWithValue}) => {
	  try {
		  const response = await refundService.getRefundList(status);
		  if (response) {
			  const {httpStatusCode, data, message} = response;

			  switch (httpStatusCode) {
				  case httpStatusCodes.SUCCESS_OK: {
					  if (data && data.data) {
						  return {
							data:{
							  httpStatusCode,
							  data: data.data,
							  message,
							}
						  };
					  } else {
						  return rejectWithValue({
							  httpStatusCode,
							  message,
						  });
					  }
				  }
				  default: {
					  return rejectWithValue({
						  httpStatusCode,
						  message,
					  });
				  }
			  }
		  } else {
			  return rejectWithValue({
				  message: "No response received",
			  });
		  }
	  } catch (error) {
		  return rejectWithValue({
			  message: "Something went wrong",
		  });
	  }
  },
);

export const getRefundById = createAsyncThunk<
iGenericResponse<any | null> | null,
{refundId:string},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("getRefundById"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async (arg, {rejectWithValue}) => {
	try {
		const response = await refundService.getRefundById(arg);
		if (response) {
			const {httpStatusCode, data, message} = response;
			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							   data:{
								data: data.data,
								message,
							   }
							}
						
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);


